import { v4 as uuid4 } from 'uuid';

export const v4 = uuid4;

export default {
  v4,
};
